import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
class Drawer extends React.Component {
    constructor(props) {
        super(props);
        this.maskClick = () => {
            const { maskClose } = this.props;
            if (maskClose) {
                this.close();
            }
        };
        this.close = () => {
            this.setState({
                visible: false,
                hidding: true,
            });
            setTimeout(() => {
                this.setState({
                    hidding: false,
                });
            }, 300);
            this.props.closeCallBack();
        };
        this.handleConfirm = () => {
            this.props.onConfirm();
            this.close();
        };
        this.state = {
            visible: false,
            hidding: false,
        };
    }
    componentWillMount() {
        if (document) {
            this.el = document.createElement('div');
            document.body.appendChild(this.el);
        }
    }
    componentDidMount() {
        this.setState({
            visible: this.props.visible,
        });
    }
    componentWillUnmount() {
        this.el && document.body.removeChild(this.el);
    }
    componentDidUpdate(preProps) {
        if (this.props.visible !== preProps.visible &&
            this.props.visible !== this.state.visible) {
            this.setState({
                visible: this.props.visible,
            });
        }
    }
    render() {
        const { visible, hidding } = this.state;
        const { children, drawerCls, zIndex, drawerTitle } = this.props;
        const stylezIndex = visible || hidding ? zIndex : -1;
        const dCls = classnames('cfm_select_pop', {
            'cfm_select_pop_hidden': !(visible || hidding),
        }, {
            'cfm_select_pop_hidding': hidding,
            'cfm_select_pop_open': visible,
        }, drawerCls);
        const wrapperCls = classnames('cfm_select_pop_wrapper', {
            'cfm_d_show': visible,
            'cfm_d_hidden': !visible,
        });
        const drawerContent = <div style={{ zIndex: stylezIndex }} className={dCls}>
      <div className='cfm_select_pop_mask' onClick={this.maskClick}/>
      <div className={wrapperCls}>
        <div className='cfm_select_pop_content'>
          <div className='cfm_select_pop_title'>
            <div onClick={this.close} className='cfm_select_pop_cancel'>Cancel</div>
            {drawerTitle}
            <div onClick={this.handleConfirm} className='cfm_select_pop_confirm'>Confirm</div>
          </div>
          <div className='cfm_select_pop_body'>{children}</div>
        </div>
      </div>
    </div>;
        if (visible) {
            if (document)
                document.body.style.overflow = 'hidden';
        }
        else {
            if (document)
                document.body.style.overflow = '';
        }
        return <React.Fragment>
      {ReactDOM.createPortal(drawerContent, this.el)}
    </React.Fragment>;
    }
}
Drawer.defaultProps = {
    maskClose: true,
    closeCallBack: () => { },
    zIndex: 1000,
};
export default Drawer;



// WEBPACK FOOTER //
// ./components/select-item/SelectDrawer.tsx